export default __webpack_public_path__ + "static/media/goopter-flashbot-building-delivery.8d523b90.jpg";